module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "p1"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "fronttitle smallcaps"
  }, [_vm._v("Guest Editors of the Best American Essays")]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("1986 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ELIZABETH HARDWICK")])]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("1987 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("GAY TALESE")])]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("1988 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ANNIE DILLARD")])]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("1989 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("GEOFFREY WOLFF")])]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("1990 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("JUSTIN KAPLAN")])]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("1991 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("JOYCE CAROL OATES")])]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("1992 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("SUSAN SONTAG")])]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("1993 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("JOSEPH EPSTEIN")])]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("1994 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TRACY KIDDER")])]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("1995 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("JAMAICA KINCAID")])]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("1996 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("GEOFFREY C. WARD")])]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("1997 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IAN FRAZIER")])]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("1998 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CYNTHIA OZICK")])]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("1999 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EDWARD HOAGLAND")])]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("2000 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ALAN LIGHTMAN")])]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("2001 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("KATHLEEN NORRIS")])]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("2002 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("STEPHEN JAY GOULD")])]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("2003 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ANNE FADIMAN")])]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("2004 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LOUIS MENAND")])]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("2005 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("SUSAN ORLEAN")])]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("2006 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LAUREN SLATER")])]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("2007 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("DAVID FOSTER WALLACE")])]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("2008 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ADAM GOPNIK")])]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("2009 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("MARY OLIVER")])]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("2010 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHRISTOPHER HITCHENS")])]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("2011 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EDWIDGE DANTICAT")])]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("2012 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("DAVID BROOKS")])]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("2013 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHERYL STRAYED")])]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("2014 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("JOHN JEREMIAH SULLIVAN")])]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("2015 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ARIEL LEVY")])]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("2016 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("JONATHAN FRANZEN")])]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("2017 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LESLIE JAMISON")])]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("2018 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HILTON ALS")])]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("2019 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("REBECCA SOLNIT")])]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("2020 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ANDRé ACIMAN")])]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("2021 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("KATHRYN SCHULZ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1152e084","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/front01.vue
// module id = 63
// module chunks = 0